const DropdownActionTypes = {
    TOGGLE_DROPDOWN_HIDDEN: 'TOGGLE_DROPDOWN_HIDDEN'
};

export default DropdownActionTypes;